import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {Icon, stringUtils, Todo} from 'front-onceforall-core';
import {Tooltip} from '@material-ui/core';

function NotificationView({notification, onUpload}) {
  const message = (
    <div className="pr-4">
      {stringUtils.getStrongs(I18n.t('notification.document.atDate', {
        documentName: notification.documentAtDate.documentName,
        year: notification.documentAtDate.year,
        projectsCount: notification.documentAtDate.projects.length
      }))}
    </div>
  );

  return (
    <Todo
      icon="document"
      message={message}
      creationDate={notification.creationDate}
    >
      <Tooltip
        title={<Translate value="dashboard.documentsToProcess.action.upload"/>}
        placement="top"
      >
        <span>
          <button
            className="button-square information-primary"
            onClick={onUpload}
          >
            <Icon icon="upload-document"/>
          </button>
        </span>
      </Tooltip>
    </Todo>
  );
}

NotificationView.propTypes = {
  notification: PropTypes.object.isRequired,
  onUpload: PropTypes.func.isRequired
};

export default NotificationView;
